import type { ComponentProps } from 'react'

import dynamic from 'next/dynamic'

import { Container, ContainerProps } from './style'

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false })

type Props = ContainerProps & ComponentProps<typeof ReactPlayer>

export default function VideoPlayer({
  width = '100%',
  height = '100%',
  maxWidth = '100%',
  maxHeight = '100%',
  // Both call sites sit behind a cover image and an explicit play button, but
  // the default `preload` still pulled 546 KB of mp4 into the homepage's
  // initial load. `preload` is a native video attribute react-player forwards.
  preload = 'none',
  ...rest
}: Props) {
  return (
    <Container
      height={height}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      width={width}
    >
      <ReactPlayer {...rest} height="100%" preload={preload} width="100%" />
    </Container>
  )
}
